import configureStore from 'state/configureStore';

const store = configureStore();

export default store;
